// src/pages/BlockedNumbers.jsx
import React from "react";
const BlockedNumbers = () => <h1>Blocked Numbers</h1>;
export default BlockedNumbers;
